// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__oNteU"};